import { FilterOption } from '../../components/_WMS/FilterComponent'

export const filterOptions: FilterOption[] = [
  {
    order: 1,
    key: 'inventoryCheckId',
    label: 'ID OT',
    type: 'numericnotnegative'
  },
  {
    order: 2,
    key: 'inventoryCheckStateId',
    label: 'Estado',
    type: 'precreated',
    canBeRepeated: true
  },
  {
    order: 3,
    key: 'tag',
    label: 'Tag',
    type: 'textempty'
  },
  {
    order: 4,
    key: 'initialCreatedDate',
    label: 'Fecha Creación Desde',
    type: 'date'
  },
  {
    order: 5,
    key: 'finalCreatedDate',
    label: 'Fecha Creación Hasta',
    type: 'date'
  },
  {
    order: 6,
    key: 'initialPromiseDate',
    label: 'Fecha Compromiso Desde',
    type: 'date'
  },
  {
    order: 7,
    key: 'finalPromiseDate',
    label: 'Fecha Compromiso Hasta',
    type: 'date'
  }
]

export const defaultFilters = [
  {
    key: 'inventoryCheckStateId',
    value: 1,
    label: 'Estado',
    displayValue: 'Creada',
    canBeRepeated: true
  },
  {
    key: 'inventoryCheckStateId',
    value: 2,
    label: 'Estado',
    displayValue: 'En Proceso',
    canBeRepeated: true
  }
]
